import { z } from "zod";

export type CheckPhoneNumberResponse = z.infer<typeof CheckPhoneNumberResponseSchema>;
export const CheckPhoneNumberResponseSchema = z.object({
  error: z.string().nullable(),
  message: z.string(),
  status: z.number().nullable(),
  success: z.boolean(),
});
